import DefaultProjectDetailView from "src/components/feature/ProjectDetailView";

const ProjectDetailView = () => {
  return <DefaultProjectDetailView />;
};

export default ProjectDetailView;
